import { t } from '@lingui/macro'
import { format } from 'date-fns/esm'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { H3 } from '@/@bothrs-ui/web/components/typography/Heading'
import { mixpanel } from '@/mixpanel'
import { AgendaSyncModal } from '@/modules/shared/components/agenda-sync-modal/AgendaSyncModal'
import { useIgnoreSyncAgenda } from '@/modules/timeline/hooks/useIgnoreSyncAgenda'
import { BookingFlowActions, BookingFlowContent, BookingFlowLayout } from './BookingFlowLayout'

import type { FlowState } from '../types/booking.type'

type SuccessContentProps = {
  flowState: FlowState
  isLoading?: boolean
}

export const SuccessContent = ({ flowState, isLoading }: SuccessContentProps) => {
  const theme = useTheme()
  const navigate = useNavigate()

  const { hasIgnoredSyncAgenda, setIgnoreSyncAgenda } = useIgnoreSyncAgenda()
  const [showAgendaSyncModal, setShowAgendaSyncModal] = useState(false)

  const slot = flowState.selectedSlot
  console.log('slot', slot)
  const location = slot?.location?.address || ''
  const locationName = slot?.location?.name || ''
  const date = slot?.start ? format(new Date(slot?.start), 'EEEE dd/MM') : ''
  const time = slot?.start ? format(new Date(slot?.start), 'HH:mm') : ''

  const handleContinue = () => {
    mixpanel.track('booking_flow_closed', {
      step: 'success',
      withTriage: !!flowState.triagePath?.length,
    })

    // navigate to home
    navigate('/home')
  }

  const handleCloseModal = () => {
    setShowAgendaSyncModal(false)
    setIgnoreSyncAgenda(true)
  }

  return (
    <>
      <BookingFlowLayout>
        <BookingFlowContent gap={theme.UI.SpacingPx.Space8}>
          <FlexColumn gap={theme.UI.SpacingPx.Space3} alignItems='center'>
            <img alt='Success icon' src='/img/booking-success.png' style={{ width: '54px', height: '54px' }} />
            <H3 noMargin>
              {t({
                id: 'appointment.booking.success.title',
                message: 'Je afspraak is succesvol ingepland!',
              })}
            </H3>
            <Span type='BodyMediumRegular' textAlign='center' color={theme.Colors.Neutrals.Darker}>
              {t({
                id: 'appointment.booking.success.description',
                message:
                  'We verwachten je op {date} om {time} in {locationName}, {location} en sturen je 3 dagen voordien nog een herinnering.',
                values: {
                  date,
                  time,
                  locationName,
                  location,
                },
              })}
            </Span>
            {hasIgnoredSyncAgenda ? null : (
              <Button
                variant='Secondary'
                onClick={() => setShowAgendaSyncModal(true)}
                prefixIcon={['fal', 'calendar-plus']}
              >
                {t({
                  id: 'appointment.booking.success.syncAgenda',
                  message: 'Toevoegen aan persoonlijke agenda',
                })}
              </Button>
            )}
          </FlexColumn>
        </BookingFlowContent>

        <BookingFlowActions>
          <Button variant='Primary' onClick={handleContinue} disabled={isLoading}>
            {t({
              id: 'global.next',
              message: 'Volgende',
            })}
          </Button>
        </BookingFlowActions>
      </BookingFlowLayout>
      <AgendaSyncModal isVisible={showAgendaSyncModal} onClose={handleCloseModal} />
    </>
  )
}
